import { render, staticRenderFns } from "./mySwitch.vue?vue&type=template&id=4f0dda60&scoped=true"
import script from "./mySwitch.vue?vue&type=script&lang=js"
export * from "./mySwitch.vue?vue&type=script&lang=js"
import style0 from "./mySwitch.vue?vue&type=style&index=0&id=4f0dda60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0dda60",
  null
  
)

export default component.exports